import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { LOGO_URL, waLink } from "@/lib/api";
import { useSiteInfo } from "@/lib/useSiteInfo";

export default function Footer() {
  const info = useSiteInfo();
  return (
    <footer data-testid="site-footer" className="bg-brand-navy text-white">
      {/* Trust counter band */}
      <div className="border-b border-white/10">
        <div className="container-x py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { n: "450+", l: "Properties Monitored" },
            { n: "1,200+", l: "Inspection Reports Delivered" },
            { n: "25+", l: "Chennai Localities Covered" },
            { n: "24 hrs", l: "Standard Report Delivery" },
          ].map((s) => (
            <div key={s.l} data-testid={`footer-stat-${s.l.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="font-display text-4xl md:text-5xl font-bold text-white">{s.n}</div>
              <div className="mt-1 text-xs uppercase tracking-[0.22em] text-brand-cyan font-semibold">{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <img src={LOGO_URL} alt="Hi-Tech Realty" className="h-14 w-14 bg-white p-1 object-contain" />
          <div className="mt-4 font-display text-2xl font-bold">Hi-Tech Realty</div>
          <p className="mt-3 text-sm text-white/70 leading-relaxed">
            Your Property. Our Responsibility. Local property care for owners who cannot be present locally — in Chennai.
          </p>
        </div>

        <div>
          <div className="eyebrow !text-white">Explore</div>
          <ul className="mt-4 space-y-2 text-sm text-white/80">
            <li><Link to="/services" className="hover:text-brand-cyan">Services</Link></li>
            <li><Link to="/pricing" className="hover:text-brand-cyan">Pricing</Link></li>
            <li><Link to="/nri-corner" className="hover:text-brand-cyan">NRI Corner</Link></li>
            <li><Link to="/properties" className="hover:text-brand-cyan">Properties</Link></li>
            <li><Link to="/how-it-works" className="hover:text-brand-cyan">How It Works</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow !text-white">Portals</div>
          <ul className="mt-4 space-y-2 text-sm text-white/80">
            <li><Link to="/login/owner" data-testid="footer-owner-login" className="hover:text-brand-cyan">Owner Login</Link></li>
            <li><Link to="/login/tenant" data-testid="footer-tenant-login" className="hover:text-brand-cyan">Tenant Login</Link></li>
            <li><Link to="/about" className="hover:text-brand-cyan">About Hi-Tech</Link></li>
            <li><Link to="/faq" className="hover:text-brand-cyan">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-brand-cyan">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow !text-white">Contact</div>
          <ul className="mt-4 space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-brand-cyan flex-shrink-0" /> <span>{info.address}</span></li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-brand-cyan" /> <a href={`tel:${info.phone.replace(/\s+/g, "")}`} className="hover:text-brand-cyan">{info.phone}</a></li>
            <li className="flex items-center gap-2"><Mail size={16} className="text-brand-cyan" /> <a href={`mailto:${info.email}`} className="hover:text-brand-cyan">{info.email}</a></li>
          </ul>
          <a
            data-testid="footer-whatsapp"
            href={waLink("Hi Hi-Tech Realty, I'd like to talk to your Chennai team.")}
            target="_blank"
            rel="noreferrer"
            className="btn-whatsapp mt-5 w-full"
          >
            Chat with Chennai Team
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col sm:flex-row items-center justify-between text-xs text-white/60">
          <div>© {new Date().getFullYear()} Hi-Tech Realty. All rights reserved.</div>
          <div className="mt-2 sm:mt-0">No vague updates. Every visit is documented.</div>
        </div>
      </div>
    </footer>
  );
}
